class Modal {
    constructor() {
        this.modalTrigger = document.getElementsByClassName("js-modalTrigger");
        this.modalClose = document.getElementsByClassName("js-closeModal");
        this.modalOverlay = document.getElementsByClassName("js-closeModalOverlay");
        this.linkOptionsMap = this.getDiviLinkOptions();
        this.events();
    }

    events() {
        Array.from(this.modalTrigger).forEach((elem) => {
            elem.addEventListener(
                'click',
                (e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    let targetUrl = elem.getAttribute('href');

                    if (!targetUrl) {
                        for (let className of elem.classList) {
                            if (this.linkOptionsMap[className]) {
                                targetUrl = this.linkOptionsMap[className];
                                break;
                            }
                        }
                    }

                    if (targetUrl) {
                        const obj = document.querySelector(targetUrl);
                        const vnoscroll = true;

                        if (obj) {
                            this.openModal(obj, vnoscroll);
                            this.escHandler(obj);
                        }
                    } else {
                        console.warn('No target URL found for the clicked element');
                    }
                },
                true
            );
        });

        Array.from(this.modalClose).forEach((elem) => {
            elem.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                this.closeModal(elem.closest('.modal'));
            });
        });

        Array.from(this.modalOverlay).forEach((elem) => {
            elem.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                this.closeModal(elem.closest('.modal'));
            });
        });
    }

    getDiviLinkOptions() {
        if (Array.isArray(window.et_link_options_data)) {
            return window.et_link_options_data.reduce((map, item) => {
                map[item.class] = item.url;
                return map;
            }, {});
        } else {
            return {};
        }
    }

    openModal(obj, vnoscroll) {
        document.body.append(obj);

        setTimeout(() => {
            obj.classList.add('is-active');
            document.body.classList.add('modal-is-active');
            setTimeout(() => {
                obj.querySelector('.modal__dialog').classList.add('dialog-is-active');
            }, 100);
        }, 100);

        if (vnoscroll) {
            document.body.classList.add('v-noscroll');
        }
    }

    escHandler(target) {
        this._escHandler = (e) => {
            if (e.which === 27) {
                this.closeModal(target);
            }
        };
        document.addEventListener('keyup', this._escHandler);
    }

    closeModal(obj) {
        if (!obj) {
            console.warn('closeModal: Modal object not found');
            return;
        }

        obj.querySelector('.modal__dialog').classList.remove('dialog-is-active');

        setTimeout(() => {
            obj.classList.remove('is-active');
            setTimeout(() => {
                document.body.classList.remove('v-noscroll');
                document.body.classList.remove('modal-is-active');
            }, 500);
        }, 300);

        if (this._escHandler) {
            document.removeEventListener('keyup', this._escHandler);
            this._escHandler = null; // Clean up the handler reference
        }
    }
}

export default Modal;
